const banner = {
  imgPath: "ภาพ",
  linkPath: "ลิงก์ URL",
  selectImg: "เลือกรูปภาพ",
  error1: "กรุณาเลือกรูปภาพ",
  error2: "กรุณาใส่คำอธิบาย",
  addbanner: "เพิ่มแบนเนอร์",
  editbanner: "แก้ไขแบนเนอร์"
} 
export default banner